import { AnalyticsReportCreationSource } from "@redotech/crdb-enums/analytics/analytics-report-creation-source";
import { AnalyticsReportStatus } from "@redotech/crdb-enums/analytics/analytics-report-status";
import { CustomAnalyticsQueryVersionSchema } from "@redotech/redo-analytics-custom-analytics/query/custom-analytics-report-query";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const SnowflakeSqlBindSchema = z.union([
  z.string(),
  z.number(),
  z.array(z.union([z.string(), z.number()])),
]);

export const getCustomReportDebug = unaryRpc({
  name: "getCustomReportDebug" as const,
  input: z.object({
    id: z.string().trim().min(1),
    teamId: z.string().trim().optional(),
  }),
  output: z.object({
    valid: z.boolean(),
    rowId: z.string().nullable(),
    publicId: z.string().nullable(),
    found: z.boolean(),
    error: z.string().nullable(),
    report: z
      .object({
        teamId: z.string(),
        teamName: z.string().nullable(),
        createdByUserId: z.string().nullable(),
        createdByName: z.string().nullable(),
        title: z.string().nullable(),
        status: z.enum(AnalyticsReportStatus),
        creationSource: z.enum(AnalyticsReportCreationSource),
        requestedQuestion: z.string(),
        reportSpec: z.string().nullable(),
        explanation: z.string().nullable(),
        errorMessage: z.string().nullable(),
        createdAt: z.date(),
        updatedAt: z.date(),
      })
      .nullable(),
    highLevelAst: z.object({
      available: z.boolean(),
      message: z.string().nullable(),
      value: z.unknown().nullable(),
    }),
    queryVersion: CustomAnalyticsQueryVersionSchema.nullable(),
    queryPlan: z.unknown().nullable(),
    queryPlanVersion: z.number().nullable(),
    snowflake: z
      .object({
        boundSql: z.string(),
        inlineSql: z.string().nullable(),
        bindings: z.array(SnowflakeSqlBindSchema),
        reportTimeZone: z.string(),
        warning: z.string().nullable(),
      })
      .nullable(),
  }),
});

export type GetCustomReportDebugInput = z.infer<
  typeof getCustomReportDebug.input
>;
export type GetCustomReportDebugOutput = z.infer<
  typeof getCustomReportDebug.output
>;
